import { getUrlParamsMapV2 } from '../../utils/browserUtils';
import { getAffiliateDetails, getAuthToken, getMMT_HLD_OBJ } from '../../utils/appUtils';
import { CMP_DETAILS_KEY, INDIA_WEBSITE_VALUE } from '../constants';
import { getCookie } from '../../service/cookieService';

const MMT_HLD = ssr.isOnClient ? window.MMT_HLD : ssr.MMT_HLD;

/**
 * @deprecated
 * please dont use this anymore
 *
 */
export const checkIfAffiliateIsValid = () => {
  const aff = getAffiliateDetails().affiliateIdentifier;
  MMT_HLD.aff = aff;
  return MMT_HLD && MMT_HLD.aff !== '' && (MMT_HLD.aff === 'GI' || MMT_HLD.aff === 'TP');
};

export const getAffiliate = () => (MMT_HLD ? MMT_HLD.aff : '');

export const isIndiaWebsite = () => {
  if (MMT_HLD.website === undefined) {
    const website = getCookie('ccde');
    MMT_HLD.website = website;
  }
  return MMT_HLD.website === INDIA_WEBSITE_VALUE;
};

export const getWebsiteValue = () => (MMT_HLD.website ? MMT_HLD.website : INDIA_WEBSITE_VALUE);

export const getLoginStatus = () => {
  const mmtAuth = getAuthToken();
  if (typeof mmtAuth !== 'undefined' && mmtAuth !== null && mmtAuth !== '') {
    return true;
  }
  return false;
};

export const saveCMPDetails = () => {
  const params = getUrlParamsMapV2();
  if (MMT_HLD.fromSEO && ssr.isOnClient) {
    localStorage.setItem(
      CMP_DETAILS_KEY,
      JSON.stringify({ cmp: 'SEO', cmpCreatedTime: Date.now() })
    );
  }
  const cmp = params.cmp || params.intid;
  if (cmp && ssr.isOnClient) {
    localStorage.setItem(CMP_DETAILS_KEY, JSON.stringify({ cmp, cmpCreatedTime: Date.now() }));
  }
};

export const getCmpDetails = () => {
  if (!ssr.isOnClient) {
    return {
      cmp: ssr?.queryParams?.cmp || ssr?.queryParams?.intid || 'SEO',
      cmpCreatedTime: Date.now(),
    };
  }
  const cmp = localStorage.getItem(CMP_DETAILS_KEY);
  return cmp ? JSON.parse(cmp) : null;
};

export const checkRVSSection = (params = {}) => {
  const POKUS_KEYS = getMMT_HLD_OBJ();
  // let flag = null;
  // if (params?.pdo) {
  //   if (params?.pdo === 'true') {
  //     flag = true;
  //   } else if (params?.pdo === 'false') flag = false;
  // } else {
  //   flag = POKUS_KEYS?.showPDO;
  // }
  return POKUS_KEYS?.showPDO;
};
